import React from 'react'
import AnalyticsIcon from '@mui/icons-material/Analytics';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const MenuItems = [
    {
        "item_id" : 0,
        "menu_name": "Dashboard",
        "menu_icon": <AssessmentRoundedIcon/>,
        "menu_route": "/straindashboard"
    },
    {
        "item_id" : 1,
        "menu_name": "ICMR-NIRBI",
        "menu_icon": <AssessmentRoundedIcon/>,
        "menu_route": "/niced"
    },
    // {
    //     "item_id" : 2,
    //     "menu_name": "RMRC-NE",
    //     "menu_icon": <AssessmentRoundedIcon/>,
    //     "menu_route": "/rmrc"
    // },
    {
        "item_id" : 3,
        "menu_name": "Whole Genome Analysis",
        "menu_icon": <AssessmentRoundedIcon/>,
        "menu_route": "/genome"
    }
]

export const getMenuItems = () => {
    return MenuItems;
} 
